import React from 'react';
import Logo from '../Img/Logo_projets&finances.png';
import { addSpace, lorem, rescueHtml } from '../components/Tools.js';


const Page3Reponsables = (props) =>
{
    const blue = '#069BD3';
    const greyChapter = '#DBDBDB';
    const height = (props.height*50/950);
    const fontsize = (props.height*12/890);
    const sizelogo = props.width/6;

    return (
        <div style={{width: '100%', height: '100%', padding: 20}}>
            
            {/* Header */}
            <div style={{display: 'flex', height: '20%'}}>
                <div style={{flex: 0.4, display: 'flex', marginLeft: 10}}>
                {props.logo && (
                    <img style={{maxHeight: props.height/8, borderRadius: 5}} src={props.logo} alt="Logo" />
                )}
                </div>

                <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{color: blue, fontSize: (fontsize+10)}}>Responsables</p>
                    <p style={{color: blue, fontSize: (fontsize+6), marginLeft: 5, fontStyle: 'italic'}}>{props.index !== null ? '('+props.index+'/'+props.indexTotal+')' : ''}</p>
                </div>

                <div style={{flex: 0.4, display: 'flex', justifyContent: 'right', marginRight: 25}}>
                    <p style={{color: 'grey', fontSize: (fontsize+4)}}>Synthèse globale des opérations</p>
                </div>
            </div>


            {/* Container */}
            <div style={{flex: 1, height: '60%', fontSize: fontsize}}>
                
                {/* Entete */}
                <div style={{flex: 1, display: 'flex', marginRight: 10, marginLeft: 10, justifyContent: 'center', alignItems: 'center', fontWeight: 'bold'}}>
                    <div style={{flex: 0.3, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>N°inventaire</p>
                    </div>
                    <div style={{width: (props.width/25), justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>État</p>
                    </div>
                    <div style={{flex: 1, alignItems: 'center', display: 'flex'}}>
                        <p style={{marginLeft: 25}}>Intitulé</p>
                    </div>
                    <div style={{flex: 0.5, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>Gestionnaire interne</p>
                    </div>
                    <div style={{flex: 0.5, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>Service référent</p>
                    </div>
                    <div style={{flex: 0.5, justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                        <p>Technicien référent</p>
                    </div>
                </div>

                {props.operations.map((operation, i) => (
                    <div
                        key={i}
                        style={{flex: 1, display: 'flex', margin: (fontsize-2), border: '1px solid '+greyChapter, borderRadius: 5}}
                    >
                        {/* N°inventaire */}
                        <div style={{flex: 0.3, display: 'flex', justifyContent: 'center'}}>
                            <p style={{display: 'flex', alignItems: 'center', height: height, overflow: 'hidden'}}>{operation.numero_inventaire || ''}</p>
                        </div>

                        {/* État / couleur */}
                        <div style={{width: (props.width/25), display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                            <div style={{border: '1px solid '+(operation.color || '#999'), backgroundColor: (operation.color || '#999'), borderRadius: '100%', width: "80%", height: "80%"}}></div>
                        </div>

                        {/* Intitulé */}
                        <div style={{flex: 1, display: 'flex'}}>
                            <p style={{display: 'flex', padding: 5, alignItems: 'center', height: height, overflow: 'hidden', fontWeight: 'bold'}}>{operation.nom || ''}</p>
                        </div>

                        {/* Gestionnaire interne */}
                        <div style={{flex: 0.5, display: 'flex', textAlign: 'center', justifyContent: 'center'}}>
                            <p style={{display: 'flex', padding: 5, alignItems: 'center', height: height, overflow: 'hidden'}}>{operation.gestionnaire_interne || ''}</p>
                        </div>

                        {/* Service référent */}
                        <div style={{flex: 0.5, display: 'flex', textAlign: 'center', justifyContent: 'center'}}>
                            <p style={{display: 'flex', padding: 5, alignItems: 'center', height: height, overflow: 'hidden'}}>{operation.service_referent || ''}</p>
                        </div>

                        {/* Technicien référent */}
                        <div style={{flex: 0.5, display: 'flex', textAlign: 'center', justifyContent: 'center'}}>
                            <p style={{display: 'flex', padding: 5, alignItems: 'center', height: height, overflow: 'hidden'}}>{operation.technicien_nom || ''}</p>
                        </div>

                    </div>
                ))}
            </div>
            
                        
            {/* Footer */}
            <div style={{display: 'flex', height: '20%', position: 'relative'}}>
                <div style={{position: 'absolute', bottom: 0, display: 'flex', marginLeft: 25, alignItems: 'center', width: 200}}>
                    <p style={{fontSize: (fontsize-2)}}>{props.date}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, left: '47%', display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <p style={{fontSize: (fontsize)}}>page : {props.pagination} / {props.countPageTotal}</p>
                </div>
                <div style={{position: 'absolute', bottom: 0, right: 0, display: 'flex', marginRight: 25, alignItems: 'center'}}>
                    <img style={{width: sizelogo}} src={Logo} />
                </div>
            </div>
            
        </div>
    );
}
  
  export default Page3Reponsables;